import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

const Preloader = ({fixed = false}) => {
	return (
		<div class={'preloader' + (fixed ? ' fixed' : '')}></div>
    );
};

Preloader.propTypes = {
	fixed: PropTypes.bool
};

export default Preloader;



// WEBPACK FOOTER //
// ./src/js/utils/preloader.js